module.exports = __webpack_public_path__ + "static/logo-biofarma-a21e558dae629cfd2c7f615fe7430313.png";